import PublicLayout from '../../../../common/global/public-layout';
import LoadingSpinner from '../../../../common/widgets/LoadingSpinner';

export const PublicInformationLoader = () => (
  <PublicLayout>
    <section className="section-main section-full information-page information-page--loading">
      <div className="information-page__loader">
        <LoadingSpinner size="large" />
      </div>
    </section>
  </PublicLayout>
);
